// Redux actions for KPI Dashboard

// Action Types
export const FETCH_MY_PERIODS_REQUEST = 'kpiDashboard/FETCH_MY_PERIODS_REQUEST';
export const FETCH_MY_PERIODS_SUCCESS = 'kpiDashboard/FETCH_MY_PERIODS_SUCCESS';
export const FETCH_MY_PERIODS_FAILURE = 'kpiDashboard/FETCH_MY_PERIODS_FAILURE';

export const FETCH_MY_KPI_REQUEST = 'kpiDashboard/FETCH_MY_KPI_REQUEST';
export const FETCH_MY_KPI_SUCCESS = 'kpiDashboard/FETCH_MY_KPI_SUCCESS';
export const FETCH_MY_KPI_FAILURE = 'kpiDashboard/FETCH_MY_KPI_FAILURE';

export const SET_SELECTED_PERIOD = 'kpiDashboard/SET_SELECTED_PERIOD';
export const SET_DASHBOARD_LOADING = 'kpiDashboard/SET_DASHBOARD_LOADING';

export const FETCH_USER_KPI_PERIODS_REQUEST = 'dashboard/FETCH_USER_KPI_PERIODS_REQUEST';
export const FETCH_USER_KPI_PERIODS_SUCCESS = 'dashboard/FETCH_USER_KPI_PERIODS_SUCCESS';
export const FETCH_USER_KPI_PERIODS_FAILURE = 'dashboard/FETCH_USER_KPI_PERIODS_FAILURE';

export const FETCH_USER_KPI_DETAILS_REQUEST = 'dashboard/FETCH_USER_KPI_DETAILS_REQUEST';
export const FETCH_USER_KPI_DETAILS_SUCCESS = 'dashboard/FETCH_USER_KPI_DETAILS_SUCCESS';
export const FETCH_USER_KPI_DETAILS_FAILURE = 'dashboard/FETCH_USER_KPI_DETAILS_FAILURE';

// Employee Preview API actions
export const FETCH_EMPLOYEE_PREVIEW_REQUEST = 'dashboard/FETCH_EMPLOYEE_PREVIEW_REQUEST';
export const FETCH_EMPLOYEE_PREVIEW_SUCCESS = 'dashboard/FETCH_EMPLOYEE_PREVIEW_SUCCESS';
export const FETCH_EMPLOYEE_PREVIEW_FAILURE = 'dashboard/FETCH_EMPLOYEE_PREVIEW_FAILURE';

// Action Creators
export const fetchMyPeriodsRequest = () => ({
    type: FETCH_MY_PERIODS_REQUEST
});

export const fetchMyPeriodsSuccess = (periods) => ({
    type: FETCH_MY_PERIODS_SUCCESS,
    payload: periods
});

export const fetchMyPeriodsFailure = (error) => ({
    type: FETCH_MY_PERIODS_FAILURE,
    payload: error
});

export const fetchMyKpiRequest = (periodId) => ({
    type: FETCH_MY_KPI_REQUEST,
    payload: periodId
});

export const fetchMyKpiSuccess = (kpiData) => ({
    type: FETCH_MY_KPI_SUCCESS,
    payload: kpiData
});

export const fetchMyKpiFailure = (error) => ({
    type: FETCH_MY_KPI_FAILURE,
    payload: error
});

export const setSelectedPeriod = (periodId) => ({
    type: SET_SELECTED_PERIOD,
    payload: periodId
});

export const setDashboardLoading = (loading) => ({
    type: SET_DASHBOARD_LOADING,
    payload: loading
});

export const fetchUserKpiPeriods = (userId) => {
    return {
        type: FETCH_USER_KPI_PERIODS_REQUEST,
        payload: { userId }
    };
};

export const fetchUserKpiDetails = (periodId, userId) => ({
    type: FETCH_USER_KPI_DETAILS_REQUEST,
    payload: { periodId, userId }
});

// Employee Preview API action creator
export const fetchEmployeePreview = () => ({
    type: FETCH_EMPLOYEE_PREVIEW_REQUEST
});